import React, { useState, useEffect, memo, useCallback } from 'react';
import { Table } from 'antd';
import { addHTTP } from '@utils/common';
function KeyContactsTable(props) {
  const { data } = props;
  const [dataSource, setDataSource] = useState([]);
  const columns = [
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
      width: '75%',
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'age',
      // width: '15%',
    },
    {
      title: 'LinkedIn',
      dataIndex: 'linkedin',
      key: 'linkedin',
      width: 100,
      align: 'center',
      render: (text) =>
        text ? (
          <span
            className="appkiticon icon-link-outline bg-434343"
            onClick={() => {
              window.open(addHTTP(text, 'http://'));
            }}
          />
        ) : null,
    },
  ];
  const buildData = useCallback((data) => {
    const dataArr = data.map((d) => {
      if (d.shouldDisplay) {
        return { title: d.title, name: d.name, linkedin: d.linkedin };
      }
      return {};
    });
    setDataSource(dataArr);
  }, []);

  useEffect(() => {
    if (Array.isArray(data)) {
      buildData(data);
    }
  }, [data, buildData]);

  return dataSource.length > 0 ? (
    <Table
      columns={columns}
      dataSource={dataSource}
      className="key-contacts-table"
      pagination={false}
    />
  ) : null;
}
export default memo(KeyContactsTable);
